module.exports = __webpack_public_path__ + "components/flag/static/square/gb-sct-adda1b20f938cc5657dd10665dc8b438.svg";